import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Typography } from '@mui/material';

type Props = {
  onClose: () => void;
};

const AvailabilityRequestedModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      maxWidth="xs"
      onClose={onClose}
      title={t('hiring-dashboard-candidates:candidates.availabilityRequestedModal.title')}
    >
      <Typography fontWeight={400}>
        {t('hiring-dashboard-candidates:candidates.availabilityRequestedModal.body')}
      </Typography>
    </Dialog>
  );
};

export default AvailabilityRequestedModal;
